export const myPropertyPhotosQueryKey = "myPropertyPhotos";
